import Formsy, { withFormsy, addValidationRule } from 'formsy-react'

import { subscribeOffersLabelSelector, subscribeNewsLabelSelector } from 'wordpress/selectors'

import './styles.scss'

//TODO Split this file into multiple components
//TODO Use SCSS modules
/* Helpers */

export const FormSection = ({ className = '', children, title, showTitle }) => (
    <div className={`form-section row ${className}`}>
        {showTitle && title && (
            <div className="col-12 section-title">
                <span>{title}</span>
            </div>
        )}
        {children}
    </div>
)

const FormControl = component => withFormsy(component)

/* Form controls */
class Control extends Component {
    static contextTypes = {
        setInputState: PropTypes.func,
        getInputState: PropTypes.func,
    }

    constructor(props) {
        super(props)

        this.onFocus = this.onFocus.bind(this)
        this.onBlur = this.onBlur.bind(this)

        this.state = {}
    }

    onBlur() {
        const { name, type } = this.props
        const { setInputState } = this.context

        setInputState(name, { focused: false, touched: true }, type)
    }

    onFocus() {
        const { name, type } = this.props
        const { setInputState } = this.context

        setInputState(name, { focused: true }, type)
    }
}

class _CheckBox extends Control {
    UNSAFE_componentWillMount() {
        const { checked, setValue } = this.props
        if (checked) setValue(checked)
    }

    render() {
        const { name, label, checked = false, className = '' } = this.props

        const {
            errorMessage: formsyErrorMessage,
            value: currentState,
            isFormSubmitted,
            isPristine,
            isValid,
            setValue,
            showError,
            showRequired,
        } = this.props

        const errorClass = showError || (!isPristine && showRequired) ? 'has-danger' : ''
        const errorMessage = isFormSubmitted || isValid ? formsyErrorMessage : null

        const value = currentState !== undefined ? currentState : checked

        return (
            <label className={`custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0 ${className} ${errorClass}`}>
                <input
                    type="checkbox"
                    name={name}
                    className="custom-control-input"
                    checked={value}
                    value={value}
                    onChange={e => setValue(e.target.checked)}
                />
                <span className="custom-control-indicator" />
                <span className="custom-control-description" dangerouslySetInnerHTML={{ __html: label }} />
                {errorMessage && <span className="form-control-feedback">{errorMessage}</span>}
            </label>
        )
    }
}

export const CheckBox = FormControl(_CheckBox)

class $Input extends Control {
    static fileTypes = ['gif', 'png', 'jpg', 'jpeg', 'pdf', 'txt']
    static contextTypes = {
        setInputState: PropTypes.func,
        getInputState: PropTypes.func,
        getServerError: PropTypes.func,
    }

    constructor(props) {
        super(props)

        this.updateValue = this.updateValue.bind(this)
    }

    updateValue(e) {
        const { setInputState } = this.context
        const { name, maxSize = 5 * 1024 * 1024, setValue, type } = this.props

        if (type === 'file') {
            const file = e.target.files[0]
            const value = e.target.value

            if (file) {
                const { translate: t } = this.props
                const reader = new FileReader()
                reader.onload = () => setValue(`${file.name};${reader.result}`)

                reader.readAsDataURL(file)

                const fileType = file.name.split('.').pop()

                if ($Input.fileTypes.indexOf(fileType) === -1) {
                    setInputState(
                        name,
                        {
                            fileName: value,
                            fileError: t('feedback.attachment.type.error'),
                        },
                        type
                    )
                } else if (maxSize && file.size && file.size > maxSize) {
                    setInputState(
                        name,
                        {
                            fileName: value,
                            fileError: t('feedback.attachment.size.error'),
                        },
                        type
                    )
                } else {
                    setInputState(name, { fileName: value, fileError: null }, type)
                }
            } else setInputState(name, { fileError: null, fileName: '' }, type)
        } else setValue(e.target.value)
    }

    render() {
        const { name, placeholder, type = 'text', className = '', required = false, validationError = '' } = this.props
        const {
            errorMessage: formsyErrorMessage,
            value,
            isFormSubmitted,
            isPristine,
            isValid,
            showError,
            showRequired,
        } = this.props
        const { getInputState, getServerError } = this.context

        const serverError = getServerError(name)

        const isFile = type === 'file'
        const { fileName, fileError, focused, touched } = getInputState(name, type)

        const errorClass =
            showError || ((!isPristine || touched) && showRequired) || serverError.length > 0 || (isFile && fileError)
                ? 'has-danger'
                : ''
        const errorMessage =
            isFormSubmitted || !isValid || serverError.length > 0 || (isFile && fileError)
                ? formsyErrorMessage || serverError || validationError || fileError
                : null

        const currentValue = isFile ? '' : value || ''

        return (
            <div className={`form-group input ${type} ${className} ${errorClass} ${focused ? 'focus' : ''}`}>
                {isFile && (
                    <div className="input-wrapper">
                        <span className={`placeholder ${fileName && 'selected-file'}`}>
                            {fileName ? fileName.replace(/^.*\\/, '') : placeholder}
                        </span>
                        <input
                            type="file"
                            value={currentValue}
                            style={{ opacity: 0 }}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                            onChange={this.updateValue}
                            ref={input => {
                                this.input = input
                            }}
                        />
                    </div>
                )}

                {!isFile && <small className="form-text typing">{placeholder}</small>}
                {!isFile && (
                    <input
                        type={type}
                        className={`form-control ${errorClass}`}
                        placeholder={focused ? '' : placeholder}
                        value={currentValue}
                        onBlur={this.onBlur}
                        onChange={this.updateValue}
                        onFocus={this.onFocus}
                        formNoValidate
                    />
                )}

                {!required && currentValue.length === 0 && (
                    <small className="form-text optional">
                        <T>feedback.field.optional</T>
                    </small>
                )}
                {errorMessage && <div className="form-control-feedback">{errorMessage}</div>}
            </div>
        )
    }
}

export const Input = compose(withTranslate, withFormsy)($Input)

addValidationRule('notZero', function (values, value) {
    return Number(value) !== 0
})

class $Select extends Control {
    UNSAFE_componentWillMount() {
        const { placeholder, options = [] } = this.props

        if (placeholder) options.unshift(placeholder)

        this.setState({ options })
    }

    render() {
        const {
            name,
            placeholder,
            className = '',
            multiple = false,
            required = false,
            validationError = '',
        } = this.props

        const {
            errorMessage: formsyErrorMessage,
            value,
            isFormSubmitted,
            isPristine,
            isValid,
            setValue,
            showError,
            showRequired,
        } = this.props

        const { getInputState } = this.context
        const { options } = this.state
        const { focused, touched } = getInputState(name, 'select')

        const errorClass = showError || ((!isPristine || touched) && showRequired) ? 'has-danger' : ''
        const errorMessage = isFormSubmitted || !isValid ? formsyErrorMessage || validationError : null

        return (
            <div className={`form-group select ${className} ${errorClass} ${focused ? 'focus' : ''}`}>
                <select
                    className={`form-control ${errorClass} ${(!value || value === '0') && 'placeholder'}`}
                    multiple={multiple}
                    onBlur={this.onBlur}
                    onChange={e => setValue(e.target.value)}
                    onFocus={this.onFocus}
                    placeholder={placeholder}
                    value={value || ''}
                    formNoValidate>
                    {options.map((v, i) => (
                        <option key={i} value={i === 0 ? i : v}>
                            {v}
                        </option>
                    ))}
                </select>

                {!required && (
                    <small className="form-text ">
                        <T>feedback.field.optional</T>
                    </small>
                )}
                {errorMessage && <div className="form-control-feedback">{errorMessage}</div>}
            </div>
        )
    }
}

export const Select = FormControl($Select)

class $TextArea extends Control {
    render() {
        const { name, placeholder, className = '', rows = 5, required = false, validationError = '' } = this.props

        const {
            errorMessage: formsyErrorMessage,
            value,
            isFormSubmitted,
            isPristine,
            isValid,
            setValue,
            showError,
            showRequired,
        } = this.props

        const { getInputState } = this.context
        const { focused, touched } = getInputState(name)

        const errorClass = showError || ((!isPristine || touched) && showRequired) ? 'has-danger' : ''
        const errorMessage = isFormSubmitted || !isValid ? formsyErrorMessage || validationError : null

        return (
            <div className={`form-group textarea ${className} ${errorClass} ${focused ? 'focus' : ''}`}>
                <small className="form-text typing">{placeholder}</small>

                <textarea
                    className={`form-control ${errorClass}`}
                    placeholder={focused ? '' : placeholder}
                    rows={rows}
                    value={value || ''}
                    onBlur={this.onBlur}
                    onChange={e => setValue(e.target.value)}
                    onFocus={this.onFocus}
                    formNoValidate
                />

                {!required && (
                    <small className="form-text">
                        <T>feedback.field.optional</T>
                    </small>
                )}
                {errorMessage && <div className="form-control-feedback">{errorMessage}</div>}
            </div>
        )
    }
}

export const TextArea = FormControl($TextArea)

/* Contact form & Sections */

class $PersonalDetails extends Component {
    render() {
        const { translate: t } = this.props
        const { showTitle = true } = this.context

        return (
            <FormSection title={t('feedback.details.title')} showTitle={showTitle} className="personal-details">
                <Input
                    name="firstname"
                    className="col-lg-6 col-sm-12"
                    placeholder={t('feedback.firstname.label')}
                    validations="isExisty"
                    validationError={t('feedback.invalid.firstname.label')}
                    required
                />
                <Input
                    name="lastname"
                    className="col-lg-6 col-sm-12"
                    placeholder={t('feedback.lastname.label')}
                    validationError={t('feedback.invalid.lastname.label')}
                    validations="isExisty"
                    required
                />
                <Input
                    name="email"
                    type="email"
                    className="col-lg-6 col-sm-12"
                    placeholder={t('feedback.email.label')}
                    validations="isEmail,maxLength:60"
                    validationError={t('feedback.invalid.email.label')}
                    required
                />
                <Input
                    name="phone"
                    type="tel"
                    className="col-lg-6 col-sm-12"
                    placeholder={t('feedback.phone.label')}
                    validations="minLength:3"
                    validationError={t('feedback.invalid.phone.label')}
                    required
                />
                <Input name="company" className="col-lg-6 col-sm-12" placeholder={t('feedback.company.label')} />
            </FormSection>
        )
    }
}

export const PersonalDetails = withTranslate($PersonalDetails)

class $Address extends Component {
    render() {
        const { showTitle = true, translate: t } = this.props

        return (
            <FormSection title={t('feedback.address.title')} showTitle={showTitle} className="address">
                <Input
                    name="address"
                    className="col-sm-12"
                    placeholder={t('feedback.address.label')}
                    validationError={t('feedback.invalid.address.label')}
                    required
                />
                <Input
                    name="zipcode"
                    className="col-lg-6 col-sm-12"
                    placeholder={t('feedback.zipcode.label')}
                    validationError={t('feedback.invalid.zipcode.label')}
                    required
                />
                <Input
                    name="city"
                    className="col-lg-6 col-sm-12"
                    placeholder={t('feedback.city.label')}
                    validationError={t('feedback.invalid.city.label')}
                    required
                />
                <Input
                    name="country"
                    className="col-lg-6 col-sm-12"
                    placeholder={t('feedback.country.label')}
                    validationError={t('feedback.invalid.country.label')}
                    required
                />
            </FormSection>
        )
    }
}

export const Address = withTranslate($Address)

const $Message = ({
    categories = [],
    showEmailField = false,
    showTitle = true,
    translate: t,
    subscribeOffersLabel,
    subscribeNewsLabel,
    optionalText,
}) => (
    <FormSection title={t('feedback.message.title')} showTitle={showTitle} className="message">
        <Select
            name="category"
            className="col-lg-6 col-sm-12 clear"
            placeholder={t('feedback.category.label')}
            options={categories.map(o => o.label)}
            validations="notZero"
            validationError={t('feedback.invalid.category.label')}
            required
        />

        <div className="clearfix" />

        <Input
            name="park"
            className="col-lg-6 col-sm-12 clear"
            placeholder={t('feedback.park.label')}
            validationError={t('feedback.invalid.park.label')}
            required
        />

        {showEmailField && (
            <Input
                name="email"
                type="email"
                className="col-lg-6 col-sm-12 clear"
                placeholder={t('feedback.email.label')}
                validations="isEmail,maxLength:60"
                validationError={t('feedback.invalid.email.label')}
                required
            />
        )}

        <div className="clearfix" />

        <Input
            name="subject"
            className="col-sm-12"
            placeholder={t('feedback.subject.label')}
            validationError={t('feedback.invalid.subject.label')}
            required
        />
        <TextArea
            name="message"
            className="col-sm-12"
            placeholder={t('feedback.message.label')}
            validationError={t('feedback.invalid.message.label')}
            required
        />
        <Input
            name="attachment"
            type="file"
            className="col-lg-6 col-sm-12 file-input"
            placeholder={t('feedback.attachment.label')}
        />

        <div className="clearfix" />

        {subscribeOffersLabel && <CheckBox name="offers" label={subscribeOffersLabel} />}
        {subscribeNewsLabel && <CheckBox name="newsletter" label={subscribeNewsLabel} />}
        {optionalText && <div className="optional-text" dangerouslySetInnerHTML={{ __html: optionalText }} />}
    </FormSection>
)

export const Message = compose(
    withTranslate,
    connect(
        createStructuredSelector({
            subscribeOffersLabel: subscribeOffersLabelSelector,
            subscribeNewsLabel: subscribeNewsLabelSelector,
        })
    )
)($Message)

export class ContactForm extends Component {
    static childContextTypes = {
        getInputState: PropTypes.func,
        getServerError: PropTypes.func,
        setInputState: PropTypes.func,
    }

    static defaultInputState = {
        focused: false,
        touched: false,
    }
    static defaultFileInputState = {
        fileName: '',
        fileError: null,
    }
    static defaultSelectState = {
        options: [],
    }

    constructor(props) {
        super(props)

        this.getInputState = this.getInputState.bind(this)
        this.setInputState = this.setInputState.bind(this)
        this.getServerError = this.getServerError.bind(this)
        this.resetForm = this.resetForm.bind(this)
        this.submitForm = this.submitForm.bind(this)

        this.state = {}
    }

    getInputState(name, forType) {
        let defaultState = ContactForm.defaultInputState

        switch (forType) {
            case 'file':
                defaultState = {
                    ...defaultState,
                    ...ContactForm.defaultFileInputState,
                }
                break
            case 'select':
                defaultState = {
                    ...defaultState,
                    ...ContactForm.defaultSelectState,
                }
                break
        }

        return this.state[name] || { ...defaultState }
    }

    setInputState(name, nextState, forType) {
        const state = this.getInputState(name, forType)
        this.setState({ [name]: { ...state, ...nextState } })
    }

    getChildContext() {
        return {
            getInputState: this.getInputState,
            getServerError: this.getServerError,
            setInputState: this.setInputState,
        }
    }

    getServerError(fieldName) {
        const { error } = this.props

        if (error && error.code === 'rest_invalid_param') {
            const {
                data: { params = {} },
            } = error

            if (params[fieldName]) return params[fieldName]
        }

        return false
    }

    resetForm() {
        this.form.reset()
        this.setState(Object.keys(this.state).reduce((o, v) => ((o[v] = undefined), o), {}))
    }

    submitForm(data) {
        const { onSubmit } = this.props

        if (onSubmit) onSubmit(data, this.resetForm)
    }

    render() {
        const { children, className = '' } = this.props

        return (
            <Formsy
                className={`contact-form ${className}`}
                onValidSubmit={this.submitForm}
                ref={form => {
                    this.form = form
                }}>
                {children}
            </Formsy>
        )
    }
}
